import { match as preview } from "../../../src/params/preview.ts";

export const matchers = { preview };